import * as React from 'react';
// @ts-ignore
import AuthActions from 'auth/AuthActions';
import { FormattedMessage } from 'react-intl';
import LayerTrigger from 'components/LayerTrigger';
import LinkConstants from 'constants/LinkConstants';
import MenuDivider from 'components/MenuDivider';
import MenuItem from 'components/MenuItem';
import ModalMenuItem from 'components/ModalMenuItem';
import NavigationMenu from 'components/NavigationMenu';
// @ts-ignore
import SupportDialog from 'support/components/SupportDialog';
// @ts-ignore
import TextAppLinkDialog from 'user/components/TextAppLinkDialog';
import TextWithIcon, { Props as TextWithIconProps } from 'components/TextWithIcon';

export type Props = {
  children?: React.ReactNode;
  isAdminOfPaidOrg: boolean;
};

const signOut = () => AuthActions.signOut();

function UserNavigationMenu(props: Props) {
  const { children, isAdminOfPaidOrg } = props;
  const commonTextWithIconProps: Partial<TextWithIconProps> = {
    iconSize: 'medium',
    gutter: 'small',
    color: 'pitch',
    iconColor: 'pitch',
  };

  const menu = (
    <NavigationMenu rowHover data-test="navigation-menu">
      <MenuItem
        menuKey="settings"
        to="/settings"
        eventElementName="Navigation-account"
        data-test="settings-menu-item">
        <TextWithIcon icon="gear" {...commonTextWithIconProps}>
          <FormattedMessage id="navigation.settings" defaultMessage="Account settings" />
        </TextWithIcon>
      </MenuItem>
      <MenuDivider />
      {isAdminOfPaidOrg && (
        <MenuItem
          data-test="learning-center-menu-item"
          target="_blank"
          menuKey="learning-center"
          href={LinkConstants.LEARNING_CENTER}
          eventElementName="Navigation-learning-center">
          <TextWithIcon icon="book" {...commonTextWithIconProps}>
            <FormattedMessage id="navigation.learningCenter" defaultMessage="Learning center" />
          </TextWithIcon>
        </MenuItem>
      )}
      <ModalMenuItem menuKey="help" modal={<SupportDialog />} data-test="help-menu-item">
        <TextWithIcon icon="question-circle" {...commonTextWithIconProps}>
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Get help" />
        </TextWithIcon>
      </ModalMenuItem>
      <ModalMenuItem menuKey="get-app" modal={<TextAppLinkDialog />} data-test="mobile-menu-item">
        <TextWithIcon icon="mobile" {...commonTextWithIconProps}>
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Get the Remind app" />
        </TextWithIcon>
      </ModalMenuItem>
      <MenuDivider />
      <MenuItem
        menuKey="logout"
        onClick={signOut}
        eventElementName="Navigation-logOut"
        data-test="logout-menu-item">
        <TextWithIcon icon="sign-out" {...commonTextWithIconProps}>
          <FormattedMessage id="navigation.logout" defaultMessage="Log out" />
        </TextWithIcon>
      </MenuItem>
    </NavigationMenu>
  );

  return (
    <LayerTrigger
      layer={menu}
      placement="bottom"
      trigger="click"
      data-test="user-navigation-menu-trigger">
      {children || null}
    </LayerTrigger>
  );
}

export default UserNavigationMenu;
